<template>
  <Transition :name="onboardingStore.transition">
    <component :is="component" />
  </Transition>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import OnboardingStepOne from '@/features/onboarding/components/OnboardingStepOne.vue'
import OnboardingStepTwo from '@/features/onboarding/components/OnboardingStepTwo.vue'
import OnboardingStepThree from '@/features/onboarding/components/OnboardingStepThree.vue'
import OnboardingStepFour from '@/features/onboarding/components/OnboardingStepFour.vue'
import OnboardingStepFive from '@/features/onboarding/components/OnboardingStepFive.vue'
import OnboardingStepSix from '@/features/onboarding/components/OnboardingStepSix.vue'
import OnboardingStepSeven from '@/features/onboarding/components/OnboardingStepSeven.vue'
import OnboardingStepEight from '@/features/onboarding/components/OnboardingStepEight.vue'
import OnboardingStepNine from '@/features/onboarding/components/OnboardingStepNine.vue'
import OnboardingStepTen from '@/features/onboarding/components/OnboardingStepTen.vue'
import OnboardingStepEleven from '@/features/onboarding/components/OnboardingStepEleven.vue'
import OnboardingStepTwelve from '@/features/onboarding/components/OnboardingStepTwelve.vue'
import { parseQuery } from 'vue-router'
import { useOnboardingStore } from '@/features/onboarding/store'
import { useWebviewStore } from '@/shared/stores/webview'

const onboardingStore = useOnboardingStore()
const webviewStore = useWebviewStore()

if (webviewStore.isActive) {
  const searchParams = parseQuery(window.location.search)
  const paramStep = Math.min(
    Number(searchParams.step || 1),
    onboardingStore.maxSteps
  )
  onboardingStore.step = paramStep
}

const stepComponents = [
  OnboardingStepOne,
  OnboardingStepTwo,
  OnboardingStepThree,
  OnboardingStepFour,
  OnboardingStepFive,
  OnboardingStepSix,
  OnboardingStepSeven,
  OnboardingStepEight,
  OnboardingStepNine,
  OnboardingStepTen,
  OnboardingStepEleven,
  OnboardingStepTwelve,
]

const component = computed(() => {
  const index = onboardingStore.step - 1
  return stepComponents[index] ?? null
})
</script>
